var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/Projects",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39444872,2 C4.7892987,2 5.17531408,2.11687605 5.50384912,2.33589941 L7.49615088,3.66410059 C7.82468592,3.88312395 8.2107013,4 8.60555128,4 L14,4 C15.1045695,4 16,4.8954305 16,6 L16,12 C16,13.1045695 15.1045695,14 14,14 L2,14 C0.8954305,14 0,13.1045695 0,12 L0,4 C0,2.8954305 0.8954305,2 2,2 L4.39444872,2 Z M4.39444872,3.5 L2,3.5 C1.75454011,3.5 1.55039163,3.67687516 1.50805567,3.91012437 L1.5,4 L1.5,12 C1.5,12.2454599 1.67687516,12.4496084 1.91012437,12.4919443 L2,12.5 L14,12.5 C14.2454599,12.5 14.4496084,12.3231248 14.4919443,12.0898756 L14.5,12 L14.5,6 C14.5,5.75454011 14.3231248,5.55039163 14.0898756,5.50805567 L14,5.5 L8.60555128,5.5 C7.99134021,5.5 7.38934486,5.3383936 6.85935483,5.03328364 L6.66410059,4.91217603 L4.67179882,3.58397485 C4.61704298,3.54747096 4.55590044,3.52231677 4.49197458,3.50960329 L4.39444872,3.5 Z",
    id: "Rectangle",
    fill: "#3368FF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsManagement);
export default __webpack_public_path__ + "static/media/projects-management.1384469cd3c9f1c785ea2b4ae274774e.svg";
export { ForwardRef as ReactComponent };